import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function phoneZodSchema({ required }: FormInputSchemaParams) {
	return z.string().superRefine((value, ctx) => {
		const trimmed = value.trim();
		if (trimmed.length === 0) {
			if (required) {
				ctx.addIssue({ code: "custom", message: "required" });
			}
			return;
		}

		const result = z
			.string()
			.min(7, { message: "minLength" })
			.max(15, { message: "maxLength" })
			.regex(/^[0-9+\s()-]*$/, { message: "phoneInvalidCharacters" })
			.safeParse(trimmed);

		if (!result.success) {
			ctx.addIssue({ code: "custom", message: result.error.issues[0]?.message ?? "invalidPhone" });
		}
	});
}
